import { usePage } from "@inertiajs/react";

import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
} from "@/components/ui/sidebar";
import { MenuItem } from "@/types/menu";
import { UserRole } from "@/types/user-role";
import { NavItem } from "./nav-item";

export function NavMain({ items }: { items: MenuItem[] }) {
  const { user } = usePage().props;
  const userRole = user?.role as UserRole | undefined;

  const visibleItems = items.filter((item) => {
    if (userRole === UserRole.SUPER_ADMIN) return true;
    return userRole != null && item.roles.includes(userRole);
  });

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Menu</SidebarGroupLabel>
      <SidebarMenu>
        {visibleItems.map((item) => (
          <NavItem item={item} key={item.title} />
        ))}
      </SidebarMenu>
    </SidebarGroup>
  );
}
